import ReactDOM from 'react-dom';

const modalRoot = document.querySelector('#dialog-root');
const DialogPortal = ({ children }) => {

  return ReactDOM.createPortal(children, modalRoot);
}

export default DialogPortal;